// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
  font-size: 0.875rem;
  border-radius: 0.25rem;
}
.btn.h-custom-36 {
  padding: 0.3rem 0.75rem;
}
.btn.small {
  font-size: 0.875em;
}
.btn.btn-primary {
  background: var(--primary-600);
  border-color: var(--primary-600);
  color: var(--black);
}
.btn.btn-primary:hover:enabled {
  background: var(--yellow-600);
  border-color: var(--yellow-600);
  color: var(--black);
}
.btn.btn-primary:active:enabled {
  background: var(--yellow-800);
  border-color: var(--yellow-800);
  color: var(--black);
}
.btn.btn-outline-primary {
  background: var(--purpleCircleBtn);
  border-color: var(--primaryHover);
  color: var(--white);
}
.btn.btn-outline-primary:hover {
  background: transparent;
  border-color: transparent;
  background-origin: border-box;
}
.btn.btn-secondary {
  background: var(--white);
  border: 0;
  color: var(--darkText);
}
.btn.btn-secondary:hover {
  background: var(--white);
}
.btn.btn-secondary.keno-btn-shadow {
  box-shadow: var(--kenoBtnShadow);
}
.btn.btn-secondary.keno-btn-shadow:hover {
  box-shadow: none;
}
.btn.btn-secondary.keno-btn-shadow:disabled {
  cursor: not-allowed;
}
.btn.btn-success {
  border: 0;
  background: var(--greenChecked);
  font-weight: 500;
}
.btn.btn-success:hover {
  border-color: var(--greenChecked);
  background: var(--greenChecked);
  opacity: 0.9;
}
.btn.btn-danger {
  color: var(--white);
  border: 0;
  background: #C60E3A;
  font-weight: 500;
}
.btn.btn-static {
  border: 0;
  background: transparent;
}
.btn.btn-static:hover {
  border: 0;
  background: transparent;
}
.btn.btn-outline-white {
  color: var(--white);
  border: 0;
  background: var(--black);
}
.btn.btn-outline-white:hover {
  border-color: var(--white);
  background: var(--white);
  color: var(--zinc-950);
}
.btn.btn-outline-secondary {
  color: var(--white);
  border: 0;
  background: var(--black);
}
.btn.btn-outline-secondary:hover {
  border-color: var(--secondary);
  background: var(--primaryHover);
}
.btn.btn-outline-warning {
  color: var(--yellow-700);
  border: 0;
  background: var(--black);
}
.btn.btn-outline-warning:hover {
  border-color: var(--yellow-700);
  background: var(--yellow-900);
  color: var(--yellow-700);
}
.btn.btn-outline-warning:is(:active, .active):enabled {
  background: var(--yellow-700);
  border-color: var(--yellow-700);
  color: var(--zinc-950);
}
.btn.btn-outline-orange {
  color: var(--orange-400);
  border: 0;
  background: var(--zinc-950);
}
.btn.btn-outline-orange:hover {
  border: 0;
  background: var(--orange-900);
  color: var(--orange-400);
}
.btn.btn-outline-orange:is(:active, .active):enabled {
  background: var(--orange-400);
  border: 0;
  color: var(--zinc-950);
}
.btn.btn-outline-danger {
  color: var(--red-500);
  border: 0;
  background: var(--black);
}
.btn.btn-outline-danger:hover {
  border: 0;
  background: rgba(239, 68, 68, 0.3);
  color: var(--red-500);
}
.btn.btn-outline-danger:is(:active, .active):enabled {
  background: var(--red-500);
  border: 0;
  color: var(--zinc-950);
}
.btn.btn-outline-info {
  color: var(--cyan-400);
  border: 0;
  background: var(--black);
}
.btn.btn-outline-info:hover {
  border: 0;
  background: var(--cyan-900);
  color: var(--cyan-400);
}
.btn.btn-outline-info:is(:active, .active):enabled {
  background: var(--cyan-400);
  border: 0;
  color: var(--zinc-950);
}
.btn:disabled {
  cursor: not-allowed;
  pointer-events: all;
}
.btn:disabled:hover {
  opacity: 0.6;
}

.btn.h-custom-36 {
  padding: 0.3rem 0.75rem;
}
.btn.btn-exa-a-primary {
  background: var(--exaAPrimary);
  border: 1px solid var(--exaAPrimary);
  color: var(--exaAWhite);
}
.btn.btn-exa-a-primary:hover:enabled {
  background: var(--exaAPrimaryHover);
  color: var(--exaAWhite);
}
.btn.btn-exa-a-primary:active:enabled {
  opacity: 0.8;
  color: var(--exaAWhite);
  border-color: var(--exaAPrimary);
}
.btn.btn-exa-a-secondary {
  background: var(--exaADarkBlue500);
  border: 1px solid var(--exaADarkBlue500);
  color: var(--exaAWhite);
}
.btn.btn-exa-a-secondary:hover:enabled {
  background: var(--exaADarkBlue800);
  color: var(--exaAWhite);
}
.btn.btn-exa-a-secondary:active:enabled {
  opacity: 0.8;
  color: var(--exaAWhite);
  border-color: var(--exaADarkBlue500);
}
.btn.btn-exa-a-warning {
  background: var(--exaAWarning);
  border: 1px solid var(--exaAWarning);
  color: var(--exaABlack);
}
.btn.btn-exa-a-warning:hover:enabled {
  background: var(--exaAWarningHover);
  color: var(--exaABlack);
}
.btn.btn-exa-a-warning:active:enabled {
  opacity: 0.8;
  color: var(--exaABlack);
  border-color: var(--exaAWarning);
}
.btn.btn-exa-a-danger {
  background: var(--exaADanger500);
  border: 1px solid var(--exaADanger500);
  color: var(--exaAWhite);
}
.btn.btn-exa-a-danger:hover:enabled {
  background: var(--exaADanger500);
  opacity: 0.9;
  color: var(--exaAWhite);
}
.btn.btn-exa-a-danger:active:enabled {
  opacity: 0.9;
  color: var(--exaAWhite);
  border-color: var(--exaADanger500);
}
.btn.btn-exa-b-primary {
  background: var(--exaBPrimary);
  background: linear-gradient(180deg, var(--exaBPrimaryHover) 0%, var(--exaBPrimary) 100%);
  border: 1px solid var(--exaBPrimary);
  color: var(--exaBWhite);
}
.btn.btn-exa-b-primary:hover:enabled {
  background: linear-gradient(180deg, var(--exaBPrimary) 0%, var(--exaBPrimaryHover) 100%);
  color: var(--exaBWhite);
}
.btn.btn-exa-b-primary:active:enabled {
  opacity: 0.8;
  color: var(--exaBWhite);
  border-color: var(--exaBPrimary);
}
.btn.btn-exa-b-secondary {
  background: var(--exaBDarkBlue500);
  border: 1px solid var(--exaBDarkBlue500);
  color: var(--exaBWhite);
}
.btn.btn-exa-b-secondary:hover:enabled {
  background: var(--exaBDarkBlue800);
  color: var(--exaBWhite);
}
.btn.btn-exa-b-secondary:active:enabled {
  opacity: 0.8;
  color: var(--exaBWhite);
  border-color: var(--exaBDarkBlue500);
}
.btn.btn-exa-b-success {
  background: linear-gradient(89.79deg, var(--exaBGreen400) 1.75%, var(--exaBGreen600) 99.86%);
  border: none;
  color: var(--exaBWhite);
}
.btn.btn-exa-b-success:hover:enabled {
  background: linear-gradient(89.79deg, var(--exaBGreen600) 1.75%, var(--exaBGreen400) 99.86%);
  color: var(--exaBWhite);
}
.btn.btn-exa-b-success:active:enabled {
  opacity: 0.8;
  color: var(--exaBWhite);
}
.btn.btn-exa-b-warning {
  background: var(--exaBWarning);
  border: 1px solid var(--exaBWarning);
  color: var(--exaBBlack);
}
.btn.btn-exa-b-warning:hover:enabled {
  background: var(--exaBWarningHover);
  color: var(--exaBBlack);
}
.btn.btn-exa-b-warning:active:enabled {
  opacity: 0.8;
  color: var(--exaBBlack);
  border-color: var(--exaBWarning);
}
.btn.btn-exa-b-cashout {
  background: var(--exaBGreen400);
  border: 1px solid var(--exaBGreen400);
  color: var(--exaBBlack);
}
.btn.btn-exa-b-cashout:hover:enabled {
  background: var(--exaBGreen600);
  border-color: var(--exaBGreen600);
  color: var(--exaBBlack);
}
.btn.btn-exa-b-cashout:active:enabled {
  opacity: 0.8;
  color: var(--exaBBlack);
  border-color: var(--exaBGreen400);
}
.btn.btn-exa-b-danger {
  background: linear-gradient(180deg, var(--exaBDanger650) 0%, var(--exaBPrimary) 100%);
  border: 1px solid var(--exaBDanger500);
  color: var(--exaBWhite);
}
.btn.btn-exa-b-danger:hover:enabled {
  background: linear-gradient(180deg, var(--exaBPrimary) 0%, var(--exaBDanger650) 100%);
  opacity: 0.9;
  color: var(--exaBWhite);
}
.btn.btn-exa-b-danger:active:enabled {
  opacity: 0.9;
  color: var(--exaBWhite);
  border-color: var(--exaBDanger500);
}
.btn.btn-outline-white {
  color: var(--white);
  border: 1px solid var(--white);
  background: var(--black);
}
.btn.btn-outline-white:hover {
  border-color: var(--white);
  background: var(--white);
  color: var(--zinc-950);
}
.btn.btn-exa-c-secondary {
  background: var(--exaCPurple200);
  border: 1px solid var(--exaCPurple200);
  color: var(--exaCPrimaryHover);
}
.btn.btn-exa-c-secondary:hover:enabled {
  background: var(--exaBDarkBlue800);
  color: var(--exaCPrimaryHover);
}
.btn.btn-exa-c-secondary:active:enabled {
  opacity: 0.8;
  color: var(--exaCPrimaryHover);
  border-color: var(--exaCPurple200);
}
.btn.btn-exa-d-secondary {
  background: var(--exaDBlue300);
  border: 1px solid var(--exaDBlue300);
  color: var(--exaEWhite);
}
.btn.btn-exa-d-secondary:hover:enabled {
  opacity: 0.8;
  color: var(--exaEWhite);
  background: var(--exaDBlue300);
  border-color: var(--exaDBlue300);
}
.btn.btn-exa-d-secondary:active:enabled {
  opacity: 1;
  color: var(--exaEWhite);
  background: var(--exaDBlue300);
  border-color: var(--exaDBlue300);
}
.btn.btn-exa-e-primary {
  background: var(--exaBPrimary);
  border: 1px solid transparent;
  background: linear-gradient(90deg, var(--exaEPrimary) 2.71%, var(--exaEPrimaryHover) 100%);
  background-origin: border-box;
  color: var(--exaEWhite);
}
.btn.btn-exa-e-primary:hover:enabled {
  background: linear-gradient(90deg, var(--exaEPrimaryHover) 2.71%, var(--exaEPrimary) 100%);
  opacity: 0.8;
  color: var(--exaEWhite);
}
.btn.btn-exa-e-primary:active:enabled {
  opacity: 1;
  color: var(--exaEWhite);
}
.btn.btn-exa-e-danger {
  background: var(--exaEDanger500);
  border: 1px solid var(--exaEDanger500);
  color: var(--exaEWhite);
}
.btn.btn-exa-e-danger:hover:enabled {
  background: var(--exaEDanger500);
  opacity: 0.9;
  color: var(--exaEWhite);
}
.btn.btn-exa-e-danger:active:enabled {
  opacity: 0.9;
  color: var(--exaEWhite);
  border-color: var(--exaEDanger500);
}
.btn.btn-exa-e-info {
  background: var(--exaEInfo);
  color: var(--exaEBlack);
}
.btn.btn-exa-e-info:hover:enabled {
  opacity: 0.8;
}
.btn.btn-exa-e-info:active:enabled {
  opacity: 1;
  color: var(--exaEBlack);
  background: var(--exaEInfo);
}
.btn.btn-plinko-primary {
  background: radial-gradient(69.86% 210.29% at 50% -83.54%, #65F6FF 0%, #0087C1 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.2117647059);
  color: var(--white);
}
.btn.btn-mine-primary {
  color: var(--white);
  background: radial-gradient(69.86% 210.29% at 50% -83.54%, #21A8F7 0%, #006098 100%);
  border: 2px solid rgba(255, 255, 255, 0.1098039216) !important;
}
.btn.btn-roulette-primary {
  color: var(--white);
  background: radial-gradient(69.86% 210.29% at 50% -83.54%, #00EC00 0%, #066206 100%);
  border: 2px solid rgba(255, 255, 255, 0.1098039216) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ui-kit/Button/Button.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,sBAAA;AACF;AACE;EACE,uBAAA;AACJ;AAEE;EACE,kBAAA;AAAJ;AAGE;EACE,8BAAA;EACA,gCAAA;EACA,mBAAA;AADJ;AAGI;EACE,6BAAA;EACA,+BAAA;EACA,mBAAA;AADN;AAII;EACE,6BAAA;EACA,+BAAA;EACA,mBAAA;AAFN;AAME;EACE,kCAAA;EACA,iCAAA;EACA,mBAAA;AAJJ;AAMI;EACE,uBAAA;EACA,yBAAA;EACA,6BAAA;AAJN;AAQE;EACE,wBAAA;EACA,SAAA;EACA,sBAAA;AANJ;AAQI;EACE,wBAAA;AANN;AASI;EACE,gCAAA;AAPN;AASM;EACE,gBAAA;AAPR;AAUM;EACE,mBAAA;AARR;AAaE;EACE,SAAA;EACA,+BAAA;EACA,gBAAA;AAXJ;AAaI;EACE,iCAAA;EACA,+BAAA;EACA,YAAA;AAXN;AAeE;EACE,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAbJ;AAgBE;EACE,SAAA;EACA,uBAAA;AAdJ;AAgBI;EACE,SAAA;EACA,uBAAA;AAdN;AAkBE;EACE,mBAAA;EACA,SAAA;EACA,wBAAA;AAhBJ;AAkBI;EACE,0BAAA;EACA,wBAAA;EACA,sBAAA;AAhBN;AAoBE;EACE,mBAAA;EACA,SAAA;EACA,wBAAA;AAlBJ;AAoBI;EACE,8BAAA;EACA,+BAAA;AAlBN;AAsBE;EACE,wBAAA;EACA,SAAA;EACA,wBAAA;AApBJ;AAsBI;EACE,+BAAA;EACA,6BAAA;EACA,wBAAA;AApBN;AAuBI;EACE,6BAAA;EACA,+BAAA;EACA,sBAAA;AArBN;AAyBE;EACE,wBAAA;EACA,SAAA;EACA,2BAAA;AAvBJ;AAyBI;EACE,SAAA;EACA,6BAAA;EACA,wBAAA;AAvBN;AA0BI;EACE,6BAAA;EACA,SAAA;EACA,sBAAA;AAxBN;AA4BE;EACE,qBAAA;EACA,SAAA;EACA,wBAAA;AA1BJ;AA4BI;EACE,SAAA;EACA,kCAAA;EACA,qBAAA;AA1BN;AA6BI;EACE,0BAAA;EACA,SAAA;EACA,sBAAA;AA3BN;AA+BE;EACE,sBAAA;EACA,SAAA;EACA,wBAAA;AA7BJ;AA+BI;EACE,SAAA;EACA,2BAAA;EACA,sBAAA;AA7BN;AAgCI;EACE,2BAAA;EACA,SAAA;EACA,sBAAA;AA9BN;AAkCE;EACE,mBAAA;EACA,mBAAA;AAhCJ;AAkCI;EACE,YAAA;AAhCN;;AAsCE;EACE,uBAAA;AAnCJ;AAuCE;EACE,8BAAA;EACA,oCAAA;EACA,uBAAA;AArCJ;AAuCI;EACE,mCAAA;EACA,uBAAA;AArCN;AAwCI;EACE,YAAA;EACA,uBAAA;EACA,gCAAA;AAtCN;AA0CE;EACE,kCAAA;EACA,wCAAA;EACA,uBAAA;AAxCJ;AA0CI;EACE,kCAAA;EACA,uBAAA;AAxCN;AA2CI;EACE,YAAA;EACA,uBAAA;EACA,oCAAA;AAzCN;AA6CE;EACE,8BAAA;EACA,oCAAA;EACA,uBAAA;AA3CJ;AA6CI;EACE,mCAAA;EACA,uBAAA;AA3CN;AA8CI;EACE,YAAA;EACA,uBAAA;EACA,gCAAA;AA5CN;AAgDE;EACE,gCAAA;EACA,sCAAA;EACA,uBAAA;AA9CJ;AAgDI;EACE,gCAAA;EACA,YAAA;EACA,uBAAA;AA9CN;AAiDI;EACE,YAAA;EACA,uBAAA;EACA,kCAAA;AA/CN;AAsDE;EACE,8BAAA;EACA,wFAAA;EAEA,oCAAA;EACA,uBAAA;AArDJ;AAuDI;EACE,wFAAA;EACA,uBAAA;AArDN;AAwDI;EACE,YAAA;EACA,uBAAA;EACA,gCAAA;AAtDN;AA0DE;EACE,kCAAA;EACA,wCAAA;EACA,uBAAA;AAxDJ;AA0DI;EACE,kCAAA;EACA,uBAAA;AAxDN;AA2DI;EACE,YAAA;EACA,uBAAA;EACA,oCAAA;AAzDN;AA6DE;EACE,4FAAA;EACA,YAAA;EACA,uBAAA;AA3DJ;AA6DI;EACE,4FAAA;EACA,uBAAA;AA3DN;AA8DI;EACE,YAAA;EACA,uBAAA;AA5DN;AAgEE;EACE,8BAAA;EACA,oCAAA;EACA,uBAAA;AA9DJ;AAgEI;EACE,mCAAA;EACA,uBAAA;AA9DN;AAiEI;EACE,YAAA;EACA,uBAAA;EACA,gCAAA;AA/DN;AAmEE;EACE,+BAAA;EACA,qCAAA;EACA,uBAAA;AAjEJ;AAmEI;EACE,+BAAA;EACA,iCAAA;EACA,uBAAA;AAjEN;AAmEI;EACE,YAAA;EACA,uBAAA;EACA,iCAAA;AAjEN;AAqEE;EACE,qFAAA;EACA,sCAAA;EACA,uBAAA;AAnEJ;AAqEI;EACE,qFAAA;EACA,YAAA;EACA,uBAAA;AAnEN;AAsEI;EACE,YAAA;EACA,uBAAA;EACA,kCAAA;AApEN;AAwEE;EACE,mBAAA;EACA,8BAAA;EACA,wBAAA;AAtEJ;AAwEI;EACE,0BAAA;EACA,wBAAA;EACA,sBAAA;AAtEN;AA4EE;EACE,gCAAA;EACA,sCAAA;EACA,8BAAA;AA1EJ;AA4EI;EACE,kCAAA;EACA,8BAAA;AA1EN;AA6EI;EACE,YAAA;EACA,8BAAA;EACA,kCAAA;AA3EN;AAkFE;EACE,8BAAA;EACA,oCAAA;EACA,uBAAA;AAhFJ;AAkFI;EACE,YAAA;EACA,uBAAA;EACA,8BAAA;EACA,gCAAA;AAhFN;AAmFI;EACE,UAAA;EACA,uBAAA;EACA,8BAAA;EACA,gCAAA;AAjFN;AAwFE;EACE,8BAAA;EACA,6BAAA;EACA,0FAAA;EACA,6BAAA;EACA,uBAAA;AAtFJ;AAwFI;EACE,0FAAA;EACA,YAAA;EAEA,uBAAA;AAvFN;AA0FI;EACE,UAAA;EACA,uBAAA;AAxFN;AA6FE;EACE,gCAAA;EACA,sCAAA;EACA,uBAAA;AA3FJ;AA6FI;EACE,gCAAA;EACA,YAAA;EACA,uBAAA;AA3FN;AA8FI;EACE,YAAA;EACA,uBAAA;EACA,kCAAA;AA5FN;AAgGE;EACE,2BAAA;EACA,uBAAA;AA9FJ;AAgGI;EACE,YAAA;AA9FN;AAiGI;EACE,UAAA;EACA,uBAAA;EACA,2BAAA;AA/FN;AAmGE;EACE,+FAAA;EACA,mDAAA;EACA,mBAAA;AAjGJ;AAoGE;EACE,mBAAA;EACA,oFAAA;EACA,8DAAA;AAlGJ;AAqGE;EACE,mBAAA;EACA,oFAAA;EACA,8DAAA;AAnGJ","sourcesContent":[".btn {\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n\n  &.h-custom-36 {\n    padding: 0.3rem 0.75rem;\n  }\n\n  &.small {\n    font-size: .875em\n  }\n\n  &.btn-primary {\n    background: var(--primary-600);\n    border-color: var(--primary-600);\n    color: var(--black);\n\n    &:hover:enabled {\n      background: var(--yellow-600);\n      border-color: var(--yellow-600);\n      color: var(--black);\n    }\n\n    &:active:enabled {\n      background: var(--yellow-800);\n      border-color: var(--yellow-800);\n      color: var(--black);\n    }\n  }\n\n  &.btn-outline-primary {\n    background: var(--purpleCircleBtn);\n    border-color: var(--primaryHover);\n    color: var(--white);\n\n    &:hover {\n      background: transparent;\n      border-color: transparent;\n      background-origin: border-box;\n    }\n  }\n\n  &.btn-secondary {\n    background: var(--white);\n    border: 0;\n    color: var(--darkText);\n\n    &:hover {\n      background: var(--white);\n    }\n\n    &.keno-btn-shadow {\n      box-shadow: var(--kenoBtnShadow);\n\n      &:hover {\n        box-shadow: none;\n      }\n\n      &:disabled {\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  &.btn-success {\n    border: 0;\n    background: var(--greenChecked);\n    font-weight: 500;\n\n    &:hover {\n      border-color: var(--greenChecked);\n      background: var(--greenChecked);\n      opacity: 0.9;\n    }\n  }\n\n  &.btn-danger {\n    color: var(--white);\n    border: 0;\n    background: #C60E3A;\n    font-weight: 500;\n  }\n\n  &.btn-static {\n    border: 0;\n    background: transparent;\n\n    &:hover {\n      border: 0;\n      background: transparent;\n    }\n  }\n\n  &.btn-outline-white {\n    color: var(--white);\n    border: 0;\n    background: var(--black);\n\n    &:hover {\n      border-color: var(--white);\n      background: var(--white);\n      color: var(--zinc-950);\n    }\n  }\n\n  &.btn-outline-secondary {\n    color: var(--white);\n    border: 0;\n    background: var(--black);\n\n    &:hover {\n      border-color: var(--secondary);\n      background: var(--primaryHover);\n    }\n  }\n\n  &.btn-outline-warning {\n    color: var(--yellow-700);\n    border: 0;\n    background: var(--black);\n\n    &:hover {\n      border-color: var(--yellow-700);\n      background: var(--yellow-900);\n      color: var(--yellow-700);\n    }\n\n    &:is(:active, .active):enabled {\n      background: var(--yellow-700);\n      border-color: var(--yellow-700);\n      color: var(--zinc-950);\n    }\n  }\n\n  &.btn-outline-orange {\n    color: var(--orange-400);\n    border: 0;\n    background: var(--zinc-950);\n\n    &:hover {\n      border: 0;\n      background: var(--orange-900);\n      color: var(--orange-400);\n    }\n\n    &:is(:active, .active):enabled {\n      background: var(--orange-400);\n      border: 0;\n      color: var(--zinc-950);\n    }\n  }\n\n  &.btn-outline-danger {\n    color: var(--red-500);\n    border: 0;\n    background: var(--black);\n\n    &:hover {\n      border: 0;\n      background: rgba(239, 68, 68, 0.30);\n      color: var(--red-500);\n    }\n\n    &:is(:active, .active):enabled {\n      background: var(--red-500);\n      border: 0;\n      color: var(--zinc-950);\n    }\n  }\n\n  &.btn-outline-info {\n    color: var(--cyan-400);\n    border: 0;\n    background: var(--black);\n\n    &:hover {\n      border: 0;\n      background: var(--cyan-900);\n      color: var(--cyan-400);\n    }\n\n    &:is(:active, .active):enabled {\n      background: var(--cyan-400);\n      border: 0;\n      color: var(--zinc-950);\n    }\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    pointer-events: all;\n\n    &:hover {\n      opacity: 0.6;\n    }\n  }\n}\n\n.btn {\n  &.h-custom-36 {\n    padding: 0.3rem 0.75rem;\n  }\n\n  // Start Exa 'A' game buttons style\n  &.btn-exa-a-primary {\n    background: var(--exaAPrimary);\n    border: 1px solid var(--exaAPrimary);\n    color: var(--exaAWhite);\n\n    &:hover:enabled {\n      background: var(--exaAPrimaryHover);\n      color: var(--exaAWhite);\n    }\n\n    &:active:enabled {\n      opacity: 0.8;\n      color: var(--exaAWhite);\n      border-color: var(--exaAPrimary);\n    }\n  }\n\n  &.btn-exa-a-secondary {\n    background: var(--exaADarkBlue500);\n    border: 1px solid var(--exaADarkBlue500);\n    color: var(--exaAWhite);\n\n    &:hover:enabled {\n      background: var(--exaADarkBlue800);\n      color: var(--exaAWhite);\n    }\n\n    &:active:enabled {\n      opacity: 0.8;\n      color: var(--exaAWhite);\n      border-color: var(--exaADarkBlue500);\n    }\n  }\n\n  &.btn-exa-a-warning {\n    background: var(--exaAWarning);\n    border: 1px solid var(--exaAWarning);\n    color: var(--exaABlack);\n\n    &:hover:enabled {\n      background: var(--exaAWarningHover);\n      color: var(--exaABlack);\n    }\n\n    &:active:enabled {\n      opacity: 0.8;\n      color: var(--exaABlack);\n      border-color: var(--exaAWarning);\n    }\n  }\n\n  &.btn-exa-a-danger {\n    background: var(--exaADanger500);\n    border: 1px solid var(--exaADanger500);\n    color: var(--exaAWhite);\n\n    &:hover:enabled {\n      background: var(--exaADanger500);\n      opacity: 0.9;\n      color: var(--exaAWhite);\n    }\n\n    &:active:enabled {\n      opacity: 0.9;\n      color: var(--exaAWhite);\n      border-color: var(--exaADanger500);\n    }\n  }\n\n  // End Exa 'A' game buttons style\n\n  // Start Exa 'B' game buttons style\n  &.btn-exa-b-primary {\n    background: var(--exaBPrimary);\n    background: linear-gradient(180deg, var(--exaBPrimaryHover) 0%, var(--exaBPrimary) 100%);\n\n    border: 1px solid var(--exaBPrimary);\n    color: var(--exaBWhite);\n\n    &:hover:enabled {\n      background: linear-gradient(180deg, var(--exaBPrimary) 0%, var(--exaBPrimaryHover) 100%);\n      color: var(--exaBWhite);\n    }\n\n    &:active:enabled {\n      opacity: 0.8;\n      color: var(--exaBWhite);\n      border-color: var(--exaBPrimary);\n    }\n  }\n\n  &.btn-exa-b-secondary {\n    background: var(--exaBDarkBlue500);\n    border: 1px solid var(--exaBDarkBlue500);\n    color: var(--exaBWhite);\n\n    &:hover:enabled {\n      background: var(--exaBDarkBlue800);\n      color: var(--exaBWhite);\n    }\n\n    &:active:enabled {\n      opacity: 0.8;\n      color: var(--exaBWhite);\n      border-color: var(--exaBDarkBlue500);\n    }\n  }\n\n  &.btn-exa-b-success {\n    background: linear-gradient(89.79deg, var(--exaBGreen400) 1.75%, var(--exaBGreen600) 99.86%);\n    border: none;\n    color: var(--exaBWhite);\n\n    &:hover:enabled {\n      background: linear-gradient(89.79deg, var(--exaBGreen600) 1.75%, var(--exaBGreen400) 99.86%);\n      color: var(--exaBWhite);\n    }\n\n    &:active:enabled {\n      opacity: 0.8;\n      color: var(--exaBWhite);\n    }\n  }\n\n  &.btn-exa-b-warning {\n    background: var(--exaBWarning);\n    border: 1px solid var(--exaBWarning);\n    color: var(--exaBBlack);\n\n    &:hover:enabled {\n      background: var(--exaBWarningHover);\n      color: var(--exaBBlack);\n    }\n\n    &:active:enabled {\n      opacity: 0.8;\n      color: var(--exaBBlack);\n      border-color: var(--exaBWarning);\n    }\n  }\n\n  &.btn-exa-b-cashout {\n    background: var(--exaBGreen400);\n    border: 1px solid var(--exaBGreen400);\n    color: var(--exaBBlack);\n\n    &:hover:enabled {\n      background: var(--exaBGreen600);\n      border-color: var(--exaBGreen600);\n      color: var(--exaBBlack);\n    }\n    &:active:enabled {\n      opacity: 0.8;\n      color: var(--exaBBlack);\n      border-color: var(--exaBGreen400);\n    }\n  }\n\n  &.btn-exa-b-danger {\n    background: linear-gradient(180deg, var(--exaBDanger650) 0%, var(--exaBPrimary) 100%);\n    border: 1px solid var(--exaBDanger500);\n    color: var(--exaBWhite);\n\n    &:hover:enabled {\n      background: linear-gradient(180deg, var(--exaBPrimary) 0%, var(--exaBDanger650) 100%);\n      opacity: 0.9;\n      color: var(--exaBWhite);\n    }\n\n    &:active:enabled {\n      opacity: 0.9;\n      color: var(--exaBWhite);\n      border-color: var(--exaBDanger500);\n    }\n  }\n\n  &.btn-outline-white {\n    color: var(--white);\n    border: 1px solid var(--white);\n    background: var(--black);\n\n    &:hover {\n      border-color: var(--white);\n      background: var(--white);\n      color: var(--zinc-950);\n    }\n  }\n\n  // End Exa 'B' game buttons style\n  // Start Exa 'C' game buttons style\n  &.btn-exa-c-secondary {\n    background: var(--exaCPurple200);\n    border: 1px solid var(--exaCPurple200);\n    color: var(--exaCPrimaryHover);\n\n    &:hover:enabled {\n      background: var(--exaBDarkBlue800);\n      color: var(--exaCPrimaryHover);\n    }\n\n    &:active:enabled {\n      opacity: 0.8;\n      color: var(--exaCPrimaryHover);\n      border-color: var(--exaCPurple200);\n    }\n  }\n\n  // End Exa 'C' game buttons style\n\n  // Start Exa 'D' game buttons style\n  &.btn-exa-d-secondary {\n    background: var(--exaDBlue300);\n    border: 1px solid var(--exaDBlue300);\n    color: var(--exaEWhite);\n\n    &:hover:enabled {\n      opacity: 0.8;\n      color: var(--exaEWhite);\n      background: var(--exaDBlue300);\n      border-color: var(--exaDBlue300);\n    }\n\n    &:active:enabled {\n      opacity: 1;\n      color: var(--exaEWhite);\n      background: var(--exaDBlue300);\n      border-color: var(--exaDBlue300);\n    }\n  }\n\n  // End Exa 'D' game buttons style\n\n  // Start Exa 'E' game buttons style\n  &.btn-exa-e-primary {\n    background: var(--exaBPrimary);\n    border: 1px solid transparent;\n    background: linear-gradient(90deg, var(--exaEPrimary) 2.71%, var(--exaEPrimaryHover) 100%);\n    background-origin: border-box;\n    color: var(--exaEWhite);\n\n    &:hover:enabled {\n      background: linear-gradient(90deg, var(--exaEPrimaryHover) 2.71%, var(--exaEPrimary) 100%);\n      opacity: 0.8;\n\n      color: var(--exaEWhite);\n    }\n\n    &:active:enabled {\n      opacity: 1;\n      color: var(--exaEWhite);\n    }\n  }\n\n\n  &.btn-exa-e-danger {\n    background: var(--exaEDanger500);\n    border: 1px solid var(--exaEDanger500);\n    color: var(--exaEWhite);\n\n    &:hover:enabled {\n      background: var(--exaEDanger500);\n      opacity: 0.9;\n      color: var(--exaEWhite);\n    }\n\n    &:active:enabled {\n      opacity: 0.9;\n      color: var(--exaEWhite);\n      border-color: var(--exaEDanger500);\n    }\n  }\n\n  &.btn-exa-e-info {\n    background: var(--exaEInfo);\n    color: var(--exaEBlack);\n\n    &:hover:enabled {\n      opacity: 0.8;\n    }\n\n    &:active:enabled {\n      opacity: 1;\n      color: var(--exaEBlack);\n      background: var(--exaEInfo);\n    }\n  }\n\n  &.btn-plinko-primary {\n    background: radial-gradient(69.86% 210.29% at 50% -83.54%, #65F6FF 0%, #0087C1 100%) !important;\n    border: 1px solid #FFFFFF36;\n    color: var(--white);\n  }\n\n  &.btn-mine-primary {\n    color: var(--white);\n    background: radial-gradient(69.86% 210.29% at 50% -83.54%, #21A8F7 0%, #006098 100%);\n    border: 2px solid #FFFFFF1C !important;\n  }\n\n  &.btn-roulette-primary {\n    color: var(--white);\n    background: radial-gradient(69.86% 210.29% at 50% -83.54%, #00EC00 0%, #066206 100%);\n    border: 2px solid #FFFFFF1C !important;\n  }\n\n  // End Exa 'E' game buttons style\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
